function FileIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 28 28"
      fill="#697474"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M7 2.333a2.33 2.33 0 00-2.322 2.334l-.011 18.666a2.33 2.33 0 002.321 2.334H21a2.34 2.34 0 002.333-2.334v-14l-7-7H7zm8.166 8.167V4.083l6.417 6.417h-6.416z" />
    </svg>
  )
}

export default FileIcon
